module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "p navigation"
  }, [_c('div', {
    staticClass: "navigation__cta"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('span', {
    staticClass: "header__links header__links--desktop"
  }, _vm._l((_vm.headerLinks), function(headerLink) {
    return _c('module-link', {
      key: headerLink.name,
      staticClass: "header__link ttu tdn fw-extrabold link",
      attrs: {
        "color": "secondary",
        "link": headerLink.name,
        "label": headerLink.label,
        "external": false
      }
    })
  }))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.isAuthenticated && !_vm.signin) ? _c('module-button', {
    attrs: {
      "button": "primary",
      "label": "Sign In"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openModal("login")
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAuthenticated) ? _c('ui-user-info') : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64bf3e8b"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ui/Navigation.vue
// module id = 127
// module chunks = 3